import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    header: {
        backgroundColor: theme.palette.background.dark,
        padding: theme.spacing(2, 4),
        borderRadius: theme.shape.borderRadius,
    },
    title: {
        color: theme.palette.secondary.main,
    },
    content: {
        padding: theme.spacing(5, 4),
    },
}));
